/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const ModLabel: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M12.8887 8C12.1777 8 11.5557 7.378 11.5557 6.667C11.5557 5.955 12.1777 5.333 12.8887 5.333C13.5997 5.333 14.2227 5.955 14.2227 6.667C14.2227 7.378 13.5997 8 12.8887 8ZM10.2227 4.444C9.51069 4.444 8.88869 3.822 8.88869 3.111C8.88869 2.4 9.51069 1.777 10.2227 1.777C10.9337 1.777 11.5557 2.4 11.5557 3.111C11.5557 3.822 10.9337 4.444 10.2227 4.444ZM5.77769 4.444C5.06669 4.444 4.44469 3.822 4.44469 3.111C4.44469 2.4 5.06669 1.777 5.77769 1.777C6.48969 1.777 7.1117 2.4 7.1117 3.111C7.1117 3.822 6.48969 4.444 5.77769 4.444ZM3.11169 8C2.40069 8 1.77769 7.378 1.77769 6.667C1.77769 5.955 2.40069 5.333 3.11169 5.333C3.82269 5.333 4.44469 5.955 4.44469 6.667C4.44469 7.378 3.82269 8 3.11169 8ZM7.99969 0C3.5557 0 -0.000305176 3.556 -0.000305176 8C-0.000305176 12.444 3.5557 16 7.99969 16C8.7107 16 9.3327 15.378 9.3327 14.667C9.3327 14.312 9.24369 14.045 8.97769 13.777C8.79969 13.511 8.62169 13.244 8.62169 12.889C8.62169 12.178 9.24369 11.556 9.95469 11.556H11.5557C14.0447 11.556 15.9997 9.6 15.9997 7.111C15.9997 3.2 12.4447 0 7.99969 0Z'
			/>
		</Svg>
	);
};

export { ModLabel };
